import axios from 'axios';
import domReady from '../helpers/dom-ready';

//  export default
class Footer {
  static init(...parameters) {
    return new Footer(...parameters);
  }

  constructor() {
    this.container = document.querySelector('.brix-footer');
    this.languageSelect = this.container.querySelector('.language-switcher');

    // Elements connected to login retailer site
    this.dealerLogin = this.container.querySelector('.brix-dealer-login-page');
    // this.dealerLogoff = this.container.querySelector('.brix-dealer-logout-page');
    this.overlay = this.container.querySelector('.login-overlay');
    this.closeIcon = this.container.querySelector('.close-icon');
    this.loginButton = this.container.querySelector('.-border');
    this.username = this.container.querySelector('.username');
    this.password = this.container.querySelector('.user-password');

    if (this.password) {
      this.password.addEventListener('input', (event) => {
        this.updateInput(event.target.value, this.password);
      });
      this.password.addEventListener('keyup', (event) => {
        if (event.keyCode === 13) {
          // if (this.loginButton) {
          //   this.loginButton.style.background = '#000';
          //   this.loginButton.style.color = '#fff';
          //   setTimeout(() => {
          //     this.loginButton.style.background = '#fff';
          //     this.loginButton.style.color = '#000';
          //   }, 200);
          // }
          this.logIn();
        }
      });
    }

    if (this.username) {
      this.username.addEventListener('input', (event) => {
        this.updateInput(event.target.value, this.username);
      });
      this.username.addEventListener('keyup', (event) => {
        if (event.keyCode === 13) {
          // if (this.loginButton) {
          //   this.loginButton.style.background = '#000';
          //   this.loginButton.style.color = '#fff';
          //   setTimeout(() => {
          //     this.loginButton.style.background = '#fff';
          //     this.loginButton.style.color = '#000';
          //   }, 200);
          // }
          this.logIn();
        }
      });
    }

    if (this.languageSelect) {
      this.languageSelect.addEventListener('change', () => {
        this.onLanguageSelect();
      });
    }

    if (this.dealerLogin) {
      this.dealerLogin.addEventListener('click', (event) => {
        this.openCloseLogInWindow(event);
      });
    }
    // if (this.dealerLogoff) {
    //   this.dealerLogoff.addEventListener('click', () => {
    //     this.logOff();
    //   });
    // }

    if (this.overlay) {
      this.overlay.addEventListener('click', (event) => {
        this.openCloseLogInWindow(event);
      });
    }

    if (this.closeIcon) {
      this.closeIcon.addEventListener('click', (event) => {
        this.openCloseLogInWindow(event);
      });
    }

    if (this.loginButton) {
      this.loginButton.addEventListener('click', () => {
        this.logIn();
      });
    }
  }

  logIn() {
    this.loginButton.classList.add('-loading');
    const endpointUrl = document.querySelector('input[name="retailer_endpoint"]').value;
    const formData = new FormData();
    formData.append('username', this.username.value);
    formData.append('password', this.password.value);

    const config = {
      headers: { 'Content-Type': 'multipart/form-data' },
    };

    axios.post(endpointUrl, formData, config)
      .then((response) => {
        if (response.data === true) {
          const buttonUrl = document.querySelector('input[name="retailer_url"]').value;
          window.location.href = buttonUrl;
          // this.clearErrorMessageToUser();
        } else if (response.data.includes('Unknown')) {
          this.errorMessageToUser(response.data, 'username');
        } else if (response.data.includes('incorrect')) {
          this.errorMessageToUser(response.data, 'password');
        } else if (response.data.includes('password')) {
          this.errorMessageToUser(response.data, 'password');
        } else if (response.data.includes('username')) {
          this.errorMessageToUser(response.data, 'username');
        } else {
          this.errorMessageToUser('Something went wrong, try again later.', 'other');
        }
        this.loginButton.classList.remove('-loading');
      })
      .catch((error) => {
        console.log(error);
        this.errorMessageToUser('Something went wrong, try again later.', 'other');
        this.loginButton.classList.remove('-loading');
      });
  }

  updateInput(value, element) {
    if (value === '') {
      element.classList.remove('-correct');
    } else {
      element.classList.add('-correct');
    }
  }

  // logOff() {
  //   const login = document.querySelector('.log-in');
  //   const logout = document.querySelector('.log-out');
  //   const overlay = document.querySelector('.login-overlay');
  //   const endpointUrl = document.querySelector('input[name="logOff_endpoint"]').value;
  //   // axios.get(endpointUrl)
  //   //   .then((response) => {
  //   //     if (response.status === 200) {
  //         // if (login && logout) {
  //         //   login.classList.add('-hidden');
  //         //   logout.classList.remove('-hidden');
  //         //   overlay.classList.add('-visible');
  //         //   overlay.classList.remove('-hidden');
  //           // setTimeout(() => {
  //           //   login.classList.remove('-hidden');
  //           //   logout.classList.add('-hidden');
  //           //   overlay.classList.remove('-visible');
  //           //   overlay.classList.add('-hidden');
  //           //   // window.location.reload(true);
  //           // }, 2000);
  //         }
  //     //   }
  //     // })
  //     // .catch((error) => {
  //     //   console.log(error);
  //     // });
  // }

  errorMessageToUser(message, type) {
    const errorMessage = document.querySelector('.error-message');
    const errorPassword = document.querySelector('.user-password');
    const errorUsername = document.querySelector('.username');
    if (errorMessage && errorPassword) {
      if (type === 'password') {
        errorMessage.innerHTML = message;
        errorPassword.classList.add('-red');
        errorPassword.value = '';
        this.updateInput('', errorPassword);
      } else {
        errorMessage.innerHTML = message;
        errorPassword.classList.add('-red');
        errorPassword.value = '';
        errorUsername.value = '';
        this.updateInput('', errorPassword);
        this.updateInput('', errorUsername);
      }
    }
  }

  clearErrorMessageToUser() {
    const errorMessage = document.querySelector('.error-message');
    const errorPassword = document.querySelector('.user-password');
    const errorUsername = document.querySelector('.username');
    if (errorMessage && errorPassword) {
      errorMessage.innerHTML = '';
      errorPassword.classList.remove('-red');
      errorUsername.value = '';
      errorPassword.value = '';
      this.updateInput('', errorPassword);
      this.updateInput('', errorUsername);
    }
  }

  onLanguageSelect() {
    const option = this.languageSelect.options[this.languageSelect.selectedIndex];
    if (option && option.value) {
      if (option.dataset.slug && window.pll_set_current_language) {
        window.pll_set_current_language(option.dataset.slug);
      }

      window.location.href = option.value;
    }
  }


  openCloseLogInWindow(event) {
    if (this.overlay) {
      if (event.target.className === 'login-overlay -visible') {
        this.overlay.classList.remove('-visible');
        this.overlay.classList.add('-hidden');
      } else if (event.target.className === 'close-icon' || event.target.parentNode.className === 'close-icon' || event.target.parentNode.parentNode.className === 'close-icon') {
        this.overlay.classList.remove('-visible');
        this.overlay.classList.add('-hidden');
        const loggingOut = document.querySelector('.log-out');
        if (loggingOut && !loggingOut.classList.contains('-hidden')) {
          window.location.href = document.location.origin;
        }
      } else if (event.target.className === 'brix-dealer-login-page') {
        this.overlay.classList.remove('-hidden');
        this.overlay.classList.add('-visible');
        this.clearErrorMessageToUser();
      }
    }
  }
}

// Register class
// if (window.brix && window.brix.registerBlock) {
//   window.brix.registerBlock('brix-footer', Footer.init);
// }

domReady(() => {
  Footer.init();
});
